import { State } from '../../types'

const current_opal_id = window.OPAL_ID || ''
const current_workspace_id = window.WORKSPACE_ID || ''
const userData = window.THIS_USER_DATA || {}

const me = {
  ...userData.profile,
  id: (userData.id || '').toString(),
  name: `${userData.first_name || ''} ${userData.last_name || ''}`,
  avatarAssetReferenceUuid: userData?.avatar_asset_reference?.uuid,
}

export const initialState: State = {
  jsonApiEntities: {},
  current_opal_id,
  current_workspace_id,
  filters: {
    isTrayOpen: false,
  },
  me,
  entityDataByView: {
    assignmentsView: {},
    personalPanel: {},
    storiesView: {},
    weekView: {},
  },
}
